<template>
  <div>
    <v-data-table :headers="headers" :items="listadoActividades">
      <template v-slot:[`item.fechaPlazo`]="{ item }">
        <template v-if="!item.completa">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                text-color="white"
                :color="setColor(item)"
                v-bind="attrs"
                v-on="on"
              >
                <span>
                  {{
                    $moment(item.fechaPlazo).format('D/M/YYYY')
                  }}
                </span>
              </v-chip>
            </template>
            <span>
              {{
                `${getPlazo(item.fechaPlazo)} ${
                  getPlazo(item.fechaPlazo) === 1 ? "día" : "días"
                }`
              }}
            </span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-chip color="grey darken-1" text-color="white">
            <span>
              {{ $moment(item.fechaPlazo).format('D/M/YYYY') }}
            </span>
          </v-chip>
        </template>
      </template>
      <template v-slot:[`item.completa`]="{ item }">
        <template v-if="!soloLectura">
          <completa-switch :actividadEditar="item"></completa-switch>
        </template>
        <template v-else>
          <v-icon v-if="item.completa" color="green"> mdi-check-bold </v-icon>
        </template>
      </template>
      <template v-if="!soloLectura" v-slot:[`item.acciones`]="{ item }">
        <v-tooltip v-if="mixValidaScopesActions(2)" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editarActividad(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip v-if="mixValidaScopesActions(3)" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrarActividad(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CompletaSwitch from '@/components/administracion/actividades/SwitchCompletar.vue';

export default {
  name: 'ListadoActividadesDesktop',
  props: {
    listadoActividades: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CompletaSwitch,
  },
  data() {
    return {
      headers: [
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        { text: 'Estatus', align: 'center', value: 'estatus' },
        { text: 'Fecha Plazo', align: 'center', value: 'fechaPlazo' },
        { text: '¿Completa?', align: 'center', value: 'completa' },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    setColor(actividad) {
      // Si la actividad ya esta completa no se asigna color
      if (actividad.completa) return 'grey darken-1';
      const plazo = this.getPlazo(actividad.fechaPlazo);
      if (plazo > 5) return '#43BC82';
      if (plazo <= 5 && plazo > 0) return '#FA8B00';
      return '#FA8B00';
    },
    getPlazo(fechaPlazo) {
      // Dia de hoy
      const fechaHoy = new Date();
      // Dia de hoy sin horas
      const fechaHoySinHora = `${fechaHoy.getFullYear()}/${
        fechaHoy.getMonth() + 1
      }/${fechaHoy.getDate()}`;
      // Dia de hoy con horas en ceros
      const fechaHoyHoraCero = new Date(`${fechaHoySinHora} 00:00:0`);
      const fechadePlazo = new Date(`${fechaPlazo} 00:00:0`);
      const a = this.$moment(fechaHoyHoraCero);
      const b = this.$moment(fechadePlazo);
      // Dias para llegar a fecha de plazo
      // Si la fecha de hoy es igual a la del plazo sumo 1 dia
      // como el disponible para realizar la actividad
      const plazo = Number(b.diff(a, 'days')) + 1;
      // cuando el plazo sea menor a cero siempre seran 0 los dias disponibles
      if (plazo < 0) return 0;
      return plazo;
    },
    editarActividad(actividad) {
      eventBus.$emit('editar-actividad', actividad);
    },
    borrarActividad(actividad) {
      eventBus.$emit('borrar-actividad', actividad);
    },
  },
};
</script>

<style lang="scss">
</style>
